// Components/Footer.js — JCUMAS 060.013
import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary text-light py-3 w-100 mt-auto">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center small px-3">
        <div>© {year} JCUMAS 060.013. Todos los derechos reservados.</div>
        <div className="mt-2 mt-md-0">
          <a href="#aviso-legal" className="text-decoration-none text-light me-3">
            Aviso legal
          </a>
          <a href="#privacidad" className="text-decoration-none text-light me-3">
            Política de privacidad
          </a>
          <a href="#accesibilidad" className="text-decoration-none text-light me-3">
            Accesibilidad
          </a>
          <a href="#soporte" className="text-decoration-none text-light">
            Soporte
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
